import React, { Component } from "react";

export default class ApprovalAllConfirmDialog extends Component {
  render() {
    return (
      <div className="col-sm-12 mt20">
        <div
          className="bg-primary"
          style={{ padding: "10px", marginBottom: "20px", marginTop: "10px" }}
        >
          <p style={{ fontSize: "20px", fontWeight: "bold" }}>
            {`${this.props.purpose} Outstanding Leaves`}
          </p>
        </div>
        <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
          {this.props.purpose === "Approve" && (
            <h3 style={{ color: "red" }}>
              The recommended action is to REJECT the leave applications or let
              the appropriate authority with the correct decision-making
              responsibility handle them.
            </h3>
          )}
          {this.props.leavesCount > 1 ? (
            // Plural
            <h3>
              {`You are about to ${this.props.purpose.toLowerCase()} all `}
              <span
                style={{
                  fontSize: 20,
                  color: `${this.props.mainColor}`,
                  fontWeight: "bold",
                }}
              >
                {this.props.leavesCount}
              </span>{" "}
              outstanding leave requests. Are you sure you want to proceed?
            </h3>
          ) : (
            // Singular
            <h3>
              {`You are about to ${this.props.purpose.toLowerCase()} `}
              <span
                style={{
                  fontSize: 20,
                  color: `${this.props.mainColor}`,
                  fontWeight: "bold",
                }}
              >
                {this.props.leavesCount}
              </span>{" "}
              outstanding leave request. Are you sure you want to proceed?
            </h3>
          )}
        </div>
        <div
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            marginTop: "30px",
          }}
        >
          <p>Selected Filters: </p>

          <div style={{ height: "180px" }}>
            {this.props.currentFilterNames.map((filter) => {
              return (
                <div key={filter.key} style={{ marginBottom: "5px" }}>
                  {filter.key} :{" "}
                  <span style={{ fontWeight: "bold" }}>{filter.value}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            marginTop: "50px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            type="button"
            className={"btn"}
            style={{
              width: "150px",
              backgroundColor: "grey",
              color: "white",
            }}
            onClick={this.props.hideDialog}
          >
            Cancel
          </button>
          <div
            style={{
              width: "50px",
            }}
          ></div>
          <button
            type="button"
            className={"btn"}
            style={{
              width: "150px",
              backgroundColor: `${this.props.mainColor}`,
              color: "white",
            }}
            onClick={this.props.onClickConfirm}
          >
            {this.props.purpose} All
          </button>
        </div>
      </div>
    );
  }
}
